export default {
  apiKey: "AIzaSyBNDAcVKr_hRxI6J9-QIrDYRaPAREq_Uhw",
  authDomain: "parsfood-site.firebaseapp.com",
  databaseURL: "https://parsfood-site.firebaseio.com",
  projectId: "parsfood-site",
  storageBucket: "parsfood-site.appspot.com",
  messagingSenderId: "35745755590",
  appId: "1:35745755590:web:9e6dc51db9a364f39102c7",
  measurementId: "G-8N1GQVMQ6L"
}
